import { useEffect } from "react";
import { initMetaPixel } from "../utils/metaPixel";

export function useMetaPixel(pixelId: string) {
  useEffect(() => {
    if (pixelId.trim() !== "") initMetaPixel(pixelId);
  }, [pixelId]);
}
